import { LOGOUT_SUCCESS } from 'reducers/currentUser';

// Logging out destroys the PHP session for every tab, but the other tabs don't know:
// their PM (hitagi) and notification (instanoti) sockets stay connected as the user,
// and the servers don't close them (hitagi only sends a logout_notification that
// nothing handles). So when this tab logs out, tell the other tabs of the site via
// localStorage; a tab that still thinks it's logged in reloads and comes back as guest,
// which closes its sockets.

const LOGOUT_KEY = 'bobtv_logout';

function isLoggedIn(user) {
    return !!user && typeof user.isLoggedIn === 'function' && user.isLoggedIn();
}

const logoutSyncMiddleware = function logoutSyncMiddleware(store) {
    if (typeof window !== 'undefined' && window.addEventListener) {
        // "storage" fires only in the other tabs, never in the one that wrote the key
        window.addEventListener('storage', function (event) {
            if (event.key !== LOGOUT_KEY || !event.newValue) return;

            if (isLoggedIn(store.getState().currentUser)) {
                window.location.reload();
            }
        });
    }

    return function (next) {
        return function (action) {
            if (action.type === LOGOUT_SUCCESS) {
                try {
                    window.localStorage.setItem(LOGOUT_KEY, String(Date.now()));
                } catch (e) {
                    // storage unavailable (private mode...): other tabs just won't be told
                }
            }

            return next(action);
        };
    };
};

export default logoutSyncMiddleware;



// WEBPACK FOOTER //
// ./src/middleware/logoutSyncMiddleware.js